import React from 'react';
import {ORANGE_COLOR_PASSPORT} from "../../../utils/consts";

const IndicatorsDataTable = ({pcs,years,type}) => {
    const yearsTdElements = 2
    const simpleTdElements = 3
    return (
        <React.Fragment>
            {!!pcs.length &&  <tr>
                <td style={{color:ORANGE_COLOR_PASSPORT}} colSpan={(years?.length*yearsTdElements)+simpleTdElements}>{type}</td>
            </tr>}
            {pcs.map((p) => (
                <tr key={p.id}>
                    <td>{p.name}</td>
                    <td>{p.unit}</td>
                    {years.map((year) => (
                        <>
                            <td key={`${p.id}_${year}_plan`}>{p[`${year}_plan`] || '-'}</td>
                            <td key={`${p.id}_${year}_projsPlan`}>{p[`${year}_projsPlan`] || '-'}</td>
                        </>
                    ))}
                    <td>{p.isKey ? 'Да' : 'Нет'}</td>
                </tr>
            ))}
        </React.Fragment>
    );
};

export default IndicatorsDataTable;